import { render } from "./Telegram.vue?vue&type=template&id=6be55ce2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Telegram.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6be55ce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6be55ce2', __exports__)) {
    api.reload('6be55ce2', __exports__)
  }
  
  module.hot.accept("./Telegram.vue?vue&type=template&id=6be55ce2", () => {
    api.rerender('6be55ce2', render)
  })

}


export default __exports__